<script>import { createEventDispatcher, onMount } from "svelte";
import metadata from "libphonenumber-js/metadata.min.json";
import { parsePhoneNumberWithError, ParseError } from "libphonenumber-js";
import { telInputAction } from "../../utils/directives/telInputAction";
import { normalizeTelInput, getCountryForPartialE164Number } from "../../utils/helpers";
import { watcher } from "../../stores";
const dispatch = createEventDispatcher();
export let country;
export let value;
export let parsedTelInput = null;
export let valid = true;
export let disabled = false;
let inputValue = value;
let prevCountry = country;
const handleInputAction = (value2) => {
  handleParsePhoneNumber(value2, country);
};
const updateCountry = (countryCode) => {
  country = countryCode;
  prevCountry = countryCode;
  return country;
};
const handleParsePhoneNumber = (input, currCountry = null) => {
  if (input) {
    const numberHasCountry = getCountryForPartialE164Number(input, { metadata });
    if (numberHasCountry && numberHasCountry !== prevCountry) {
      updateCountry(numberHasCountry);
    }
    try {
      parsedTelInput = normalizeTelInput(
        parsePhoneNumberWithError(input, currCountry ?? numberHasCountry)
      );
    } catch (err) {
      if (err instanceof ParseError) {
        parsedTelInput = {
          isValid: false,
          error: err.message
        };
        dispatch("parseError", err.message);
      } else {
        throw err;
      }
    }
    if (parsedTelInput?.isValid && parsedTelInput?.formatOriginal) {
      if (inputValue === parsedTelInput?.formatOriginal) {
        inputValue = null;
      }
      inputValue = parsedTelInput?.formatOriginal;
    }
    value = parsedTelInput?.e164 ?? null;
    valid = parsedTelInput?.isValid ?? false;
    dispatch("valid", valid);
    dispatch("parseInput", parsedTelInput);
  } else {
    if (currCountry !== prevCountry) {
      value = null;
      inputValue = "";
      valid = true;
    }
    prevCountry = currCountry;
  }
};
const initialize = () => {
  if (value && country) {
    handleParsePhoneNumber(value, country);
  } else if (value) {
    const numberHasCountry = getCountryForPartialE164Number(value, { metadata });
    if (numberHasCountry) {
      updateCountry(numberHasCountry);
      handleParsePhoneNumber(value, country);
    } else {
      handleParsePhoneNumber(value);
    }
  }
};
onMount(() => {
  initialize();
});
let initRun = true;
const watchFunction = () => {
  if (!initRun) {
    handleParsePhoneNumber(null, country);
  }
  initRun = false;
};
const countryChangeWatch = watcher(null, watchFunction);
$:
  $countryChangeWatch = country;
</script>

<input
	{disabled}
	type="tel"
	value={inputValue}
	{...$$restProps}
	class={$$props.class}
	on:beforeinput
	on:blur
	on:change
	on:focus
	on:input
	on:keydown
	on:keypress
	on:keyup
	on:paste
	use:telInputAction={handleInputAction}
/>
